import React, { useEffect, useState } from 'react';
import { toast } from 'sonner';
import { API, axios } from '../../utils/api';
import Icona from '../cliente/Icone';

// Impostazioni → Regole dei consigli (le regole del motore dei consigli, backend/consigli.py) e Codici invito (i codici
// per i nuovi collaboratori, dalla variabile CODICI_INVITO_COLLABORATORI, e quelli dei clienti pre-registrati).

export const RegoleConsigli = () => {
  const [regole, setRegole] = useState(null);
  useEffect(() => { axios.get(`${API}/consigli/regole`).then((r) => setRegole(r.data)).catch(() => setRegole([])); }, []);
  return (
    <section className="card" data-testid="regole-consigli">
      <div className="ttl"><div className="i"><Icona nome="stella" /></div><h2>Regole dei consigli {regole ? <small>{regole.length}</small> : null}</h2></div>
      <p className="imp-nota" style={{ marginBottom: '.8rem' }}>I consigli in Oggi e in agenda nascono da queste regole, senza servizi esterni. Un consiglio scartato non torna; uno eseguito sparisce.</p>
      {!regole && <p className="vuoto">Carico le regole…</p>}
      <div className="imp-righe">
        {(regole || []).map((r, i) => (
          <div key={r.id}>
            <span className="numero">{i + 1}</span>
            <div style={{ flex: 1, minWidth: 0 }}><b>{r.nome}</b><span className="descr" style={{ display: 'block' }}>{r.descrizione}</span></div>
          </div>
        ))}
      </div>
    </section>
  );
};

export const CodiciInvito = () => {
  const [dati, setDati] = useState(null);
  useEffect(() => { axios.get(`${API}/admin/codici-invito`).then((r) => setDati(r.data)).catch(() => setDati({ codici: [], preregistrati: [] })); }, []);
  const copia = (testo) => { navigator.clipboard?.writeText(testo).then(() => toast.success('Copiato')).catch(() => {}); };
  if (!dati) return <p className="vuoto">Carico i codici…</p>;
  return (
    <div className="imp-griglia" data-testid="codici-invito">
      <section className="card">
        <div className="ttl"><div className="i"><Icona nome="chiave" /></div><h2>Codici per i nuovi collaboratori</h2></div>
        <p className="imp-nota">
          Il collaboratore si registra da <button type="button" className="link" onClick={() => copia(dati.link_registrazione)}>{dati.link_registrazione}</button> con
          uno di questi codici: il codice decide il gruppo. I codici si cambiano su Railway (variabile <code>CODICI_INVITO_COLLABORATORI</code>, poi redeploy).
        </p>
        {!dati.codici.length && <p className="imp-nota w" style={{ marginTop: '.6rem' }}>Nessun codice impostato: per ora nessun collaboratore può registrarsi da solo.</p>}
        <div className="imp-righe" style={{ marginTop: '.6rem' }}>
          {dati.codici.map((c) => (
            <div key={c.codice}>
              <button type="button" className="codice" onClick={() => copia(c.codice)} title="Copia">{c.codice}</button>
              <span className="tag t-o">gruppo {c.gruppo}</span>
              <span className="descr">{c.collaboratori} collaborator{c.collaboratori === 1 ? 'e' : 'i'} nel gruppo</span>
            </div>
          ))}
        </div>
      </section>
      <section className="card">
        <div className="ttl"><div className="i b"><Icona nome="persone" /></div><h2>Codici dei clienti pre-registrati {dati.preregistrati.length ? <small>{dati.preregistrati.length}</small> : null}</h2></div>
        <p className="imp-nota">Il cliente lo scrive quando si registra e ritrova tutto quello che è già stato inserito per lui.</p>
        {!dati.preregistrati.length && <p className="vuoto" style={{ marginTop: '.6rem' }}>Nessun cliente in attesa di registrarsi.</p>}
        <div className="imp-righe" style={{ marginTop: '.6rem' }}>
          {dati.preregistrati.map((c) => (
            <div key={c.id}>
              <b>{c.nome}</b>
              <button type="button" className="codice" onClick={() => copia(c.codice)} title="Copia">{c.codice}</button>
              {c.di && <span className="descr">inserito da {c.di}</span>}
            </div>
          ))}
        </div>
      </section>
    </div>
  );
};
